import React from 'react';
import { DataGrid, gridClasses } from '@mui/x-data-grid';
import { useTheme, alpha } from '@mui/material/styles';
import CustomPagination from './CustomPagination';
import CustomToolbar from './CustomToolbar';
import "./DataGrid.scss";

const ODD_OPACITY = 0.2;
export default function StyledDataGrid(props) {
    const theme = useTheme();
    return <DataGrid
                disableSelectionOnClick
                disableColumnSelector
                disableDensitySelector
                pagination
                components={{
                    Toolbar: CustomToolbar,
                    Pagination: CustomPagination
                }}
                componentsProps={{
                    toolbar: {
                      hideCSV: props.hideCSV,
                      showQuickFilter: (props.showQuickFilter === false) ? props.showQuickFilter : true,
                      quickFilterProps: { debounceMs: 500 },
                      csvOptions: props.csvOptions
                    },
                }}
                getRowClassName={(params) =>
                    params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                }
                sx={{
                    [`& .${gridClasses.row}.even`]: {
                        backgroundColor: "#F4F8FB",
                        '&:hover, &.Mui-hovered': {
                            backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
                            '@media (hover: none)': {
                                backgroundColor: 'transparent',
                            },
                        },
                        '&.Mui-selected': {
                            backgroundColor: alpha(
                                theme.palette.primary.main,
                                ODD_OPACITY + theme.palette.action.selectedOpacity,
                            ),
                            '&:hover, &.Mui-hovered': {
                                backgroundColor: alpha(
                                    theme.palette.primary.main,
                                    ODD_OPACITY +
                                    theme.palette.action.selectedOpacity +
                                    theme.palette.action.hoverOpacity,
                                ),
                                // Reset on touch devices, it doesn't add specificity
                                '@media (hover: none)': {
                                    backgroundColor: alpha(
                                        theme.palette.primary.main,
                                        ODD_OPACITY + theme.palette.action.selectedOpacity,
                                    ),
                                },
                            },
                        },
                    }
                }}
                {...props}
                disableRowSelectionOnClick
            />
}